export const viewedVetServicesModalEvent = () => ({
  type: 'Vet Services Landing Page Viewed',
});

export const initiateVetServicesEvent = () => ({
  type: 'Vet Services Initiatied',
});
